export const paymentStatuses = [
  { value: 0, label: "Created" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Error" },
  { value: 3, label: "Cancelled" },
  { value: 4, label: "Refunded" },
  { value: 5, label: "Processing" },
];
